<div class="d-flex flex-column flex-lg-row">
  @for (item of items(); track item.id) {
    <div
      class="col border-left border-gray4 seo-exit-block pl-0 pb-3 pb-lg-0 pr-lg-3 pl-lg-4 d-flex flex-column justify-content-between"
    >
      @if (!item.h4) {
        <p><strong>{{ item.title }}</strong></p>
      } @else {
        <h4 class="mb-1">{{ item.title }}</h4>
      }
      <p class="h-100">{{ item.description }}</p>
      <p class="text-center text-md-left mb-0 pb-0">
        <a
          href=""
          class="btn btn-primary"
          (click)="emitLoginEvent(item);false"
          [attr.data-e2e]="e2e() + '-login-' + item.id"
        >
          {{ item.confirmationLabel }}
        </a>
      </p>
    </div>
  }
</div>
